import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListSessionIdCell } from './emsp-bo-charging-session-list-session-id.cell';
import { EmspBoChargingSessionListSessionIdHeader } from './emsp-bo-charging-session-list-session-id.header';

export const EmspBoChargingSessionListSessionIdColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['sessionId']
> = {
  enableSorting: true,
  header: EmspBoChargingSessionListSessionIdHeader,
  cell: EmspBoChargingSessionListSessionIdCell,
  meta: { maxWidth: '130px', width: '120px', minWidth: '80px' },
};
